import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getMaterialTypesFromProducts } from '../../../helpers/material';
import { mapOptionsOrder } from '../../../helpers/optionsSort';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  materialType: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (materialType, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      materialType,
    },
  });

export const MaterialType = () => {
  const [state, send] = useService(productBuilderMachine);
  const materialTypes = getMaterialTypesFromProducts(state.context.products);
  const productType = getBaseProductType(state.context);

  if (isCurrentState('materialType', state) && materialTypes.length === 0) {
    throwError(state);
  }

  const blindType =
    typeof productType === 'string' ? productType.toLowerCase() : 'blind';

  const captionProductType: string = blindType.includes('shutter')
    ? 'shutter'
    : blindType.includes('curtain')
      ? 'curtain'
      : 'blind';

  const materialTypesOrder = ['Blockout', 'Light Filter', 'Sunscreen', 'Sheer'];

  let sortedMaterialTypes = mapOptionsOrder(materialTypes, materialTypesOrder);

  return (
    <SectionContent>
      <Heading>Material</Heading>
      <Caption>Choose your {captionProductType} material</Caption>
      <Selector isSlider={true}>
        {sortedMaterialTypes.map(materialType => {
          const isSelected = materialType === state.context.custom.materialType;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'materialType',
            materialType,
          );

          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(materialType, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={materialType}
              description={description}
              key={materialType}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
